import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { 
  M07_MODULE_INFO, 
  M07_TOPICS, 
  getAllM07Problems 
} from '../data/mathExercises/M07_ExponentialLogarithmicFunctions.js';

const M07ExponentialLogarithmicExercise = ({ onProgress }) => {
  const topics = M07_TOPICS;
  const problems = getAllM07Problems();
  const moduleInfo = M07_MODULE_INFO;

  return (
    <ExerciseInterface
      moduleInfo={moduleInfo}
      topics={topics}
      problems={problems}
      onProgress={onProgress}
      className="m07-exercise"
    />
  );
};

export default M07ExponentialLogarithmicExercise; 